import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { LanguageService, NgxToastrService, TrainService, UtilsService } from "@core/services";
import { TrainSeatSelectionComponent } from "../train-seat-selection/train-seat-selection.component";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { TrainsInfo } from "@core/models/trainsInfo";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-train-extra-selection",
  templateUrl: "./train-extra-selection.component.html",
  styleUrls: ["./train-extra-selection.component.scss"],
})
export class TrainExtraSelectionComponent implements OnInit, OnDestroy {
  @Input() stepper: MatStepper;
  trainsInfo;

  buttonsSeatOutward: string[] = [];
  buttonsSeatReturn: string[] = [];
  pendingRequests = 0;
  hasError = false;
  extraError: boolean = false
  seatError: boolean = false
  constructor(
    private dialog: MatDialog,
    public trainService: TrainService,
    private utilsService: UtilsService,
    private translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    private langService: LanguageService,
  ) {
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });
    this.extraError = false
    this.seatError = false
    this.utilsService.socket.on("select-extras", (res) => {
      this.extraError = this.selectExtrasResponse(res);
      this.pendingRequests--;
      this.finishStep();
    });
    this.utilsService.socket.on("select-seats", (res) => {
      this.seatError = this.selectSeatsResponse(res);
      this.pendingRequests--;
      this.finishStep();
    });
    
  }

  finishStep() {
    if (this.pendingRequests === 0) {
      this.utilsService.loadingTrains = false;

      if (!this.extraError && !this.seatError)
      this.goNextStep()
    }
  }

  ngOnDestroy(): void {
    this.utilsService.socket.off("select-extras");
    this.utilsService.socket.off("select-seats");
  }

  ngOnInit(): void {
    console.log(this.trainsInfo.sectionExtras)
    console.log(this.trainsInfo.seatMaps)
    this.trainsInfo?.selectedTrains?.selectedOutwardTrain?.sections?.forEach((s) => {
      if (s.sectionId && !this.buttonsSeatOutward[s.sectionId]) {
        this.buttonsSeatOutward[s.sectionId] = 'preference';
      }
    })
    this.trainsInfo?.selectedTrains?.selectedReturnTrain?.sections?.forEach((s) => {
      if (s.sectionId && !this.buttonsSeatReturn[s.sectionId]) {
        this.buttonsSeatReturn[s.sectionId] = 'preference';
      }
    })

    if (this.trainsInfo.selectedSeats?.outward && this.trainsInfo.selectedSeats?.outward.length > 0) {
      this.trainsInfo.selectedSeats?.outward.forEach((s) => this.buttonsSeatOutward[s.sectionId] = 'select')
    }

    if (this.trainsInfo.selectedSeats?.return && this.trainsInfo.selectedSeats?.return.length > 0) {
      this.trainsInfo.selectedSeats?.return.forEach((s) => this.buttonsSeatReturn[s.sectionId] = 'select')
    }
  }

  minSeatPrice() {
    const prices = this.trainsInfo.seatMaps
      .map(seatMap => seatMap.carriages
        .map(carriage => carriage.decks
          .map(deck => deck.seats
            .map(seat => seat.passengersPrice
              .map(priceObj => priceObj.price || 0)
            )
          )
        )
      );

    const minPrice = Math.min(...prices);
    return minPrice;
  }

  isSelectDisabled(operation: string, extra: any, sectionId: string, way: string) {
    const extraF = this.trainsInfo?.selectedExtras?.[way]?.find((e) => e.id === extra.id)
    if (extraF && operation === 'add') {
      return extraF?.quantity >= extra.availableQuantity
    } else if (extraF && operation === 'remove') {
      return extraF?.length <= 0 || extraF?.quantity <= 0
    } else if (!extraF && operation === 'add') {
      return extra.availableQuantity <= 0
    } else if (!extraF && operation === 'remove') {
      return true
    }
  }

  deleteSeats(way, sectionId) {
    way === 'outward' ? this.buttonsSeatOutward[sectionId] = 'preference' : this.buttonsSeatReturn[sectionId] = 'preference'
    const seat = this.trainsInfo.selectedSeats?.[way]?.find((seat) => seat.sectionId === sectionId);
    const index = this.trainsInfo?.selectedSeats?.[way]?.indexOf(seat);
    if (index > -1)
      this.trainsInfo?.selectedSeats?.[way]?.splice(index, 1)
  }

  selectExtra(operation: string, extra: any, sectionId: string, way: string) {
    if (!this.trainsInfo?.selectedExtras) {
      this.trainsInfo.selectedExtras = {
        outward: [],
        return: []
      }
    } else if (!this.trainsInfo?.selectedExtras[way]) {
      this.trainsInfo.selectedExtras[way] = [];
    }
    const extraF = this.trainsInfo?.selectedExtras[way].find((e) => e.id === extra.id)
    const index = this.trainsInfo?.selectedExtras[way].indexOf(extraF);
    if (operation === 'add') {
      if (extraF /* && extraF.availableQuantity > extraF.quantity */) {
        extraF.quantity += 1;
      } else {
        this.trainsInfo?.selectedExtras[way].push({
          ...extra,
          quantity: 1,
          sectionId: sectionId
        })
      }
    } else {
      if (extraF && extraF.quantity > 1) {
        extraF.quantity -= 1;
      } else {
        this.trainsInfo?.selectedExtras[way].splice(index, 1)
      }
    }

  }

  openSeatModal(way: number, section, s, train) {
    way === 0 ? this.buttonsSeatOutward[s] = 'select' : this.buttonsSeatReturn[s] = 'select'
    const seatsDialog = this.dialog.open(TrainSeatSelectionComponent, {
      height: "auto",
      width: "90%",
      panelClass: "seats-train-dialog",
      data: { modal: true },
    });
    seatsDialog.componentInstance.firstTrain = way === 0 ? true : false;
    seatsDialog.componentInstance.train = train;
    seatsDialog.componentInstance.section = section;
    seatsDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.trainsInfo.selectedSeats = result;
        way === 0 ? this.buttonsSeatOutward[s] = 'select' : this.buttonsSeatReturn[s] = 'select'
      } else{
        way === 0 ? this.buttonsSeatOutward[s] = 'preference' : this.buttonsSeatReturn[s] = 'preference'
      } 
    });
  }

  goNextStep() {
    this.stepper.next();
  }

  onSelect() {
    this.hasError = false;
    this.pendingRequests = 0;
    this.trainsInfo.selectedTrains.selectedOutwardTrain.extras = []
    this.trainsInfo.selectedTrains.selectedOutwardTrain.seats = []
    if((this.trainsInfo.selectedExtras && (this.trainsInfo.selectedExtras.outward.length > 0 || this.trainsInfo.selectedExtras.return.length > 0)) || (this.trainsInfo.selectedSeats && (this.trainsInfo.selectedSeats.outward.length > 0 || this.trainsInfo.selectedSeats.return.length > 0))) {
      if (this.extraError && !this.seatError) {
        this.onSelectExtras()
      } else if (!this.extraError && this.seatError) {
          this.onSelectSeats()
      } else {
        this.onSelectExtras()
        this.onSelectSeats()
      }
    } else {
      this.goNextStep()
    }
  }

  onSelectExtras() {
    if (this.trainsInfo.selectedTrains.selectedReturnTrain) {
      this.trainsInfo.selectedTrains.selectedReturnTrain.extras = []
    }
    if (this.trainsInfo.selectedExtras && (this.trainsInfo.selectedExtras.outward.length > 0 || this.trainsInfo.selectedExtras.return.length > 0)) {
      this.trainsInfo.selectedTrains.selectedOutwardTrain.sections.forEach((s) => s.selectedExtras = this.trainsInfo.selectedExtras.outward.filter((extras) => extras.sectionId === s.sectionId) )
      if (this.trainsInfo.selectedTrains.selectedReturnTrain)
        this.trainsInfo.selectedTrains.selectedReturnTrain.sections.forEach((s) => s.selectedExtras = this.trainsInfo.selectedExtras.return.filter((extras) => extras.sectionId === s.sectionId) )
      const correlation = crypto.randomUUID();

      const request = {
        language: this.langService.getLanguage(),
        itineraryId: this.trainsInfo.itineraryId,
        extras: { ...this.trainsInfo.selectedExtras },
        correlationId: correlation,
      }
      request.extras.outward.forEach((e) => {
        delete e.availableQuantity;
        delete e.selectedQuantity;
      })
      if (request.extras.return && request.extras.return.length > 0) {
        request.extras.return.forEach((e) => {
          delete e.availableQuantity;
          delete e.selectedQuantity;
        })
      }
      this.trainService.addCorrelation(correlation);
      this.pendingRequests++;
      this.trainService.selectExtrasTrains(request).subscribe(
        (s) => {
        },
        (err) => {
        })
    }
    this.utilsService.loadingTrains = this.pendingRequests > 0;
  }

  selectExtrasResponse(res) {
    if (this.trainService.existsCorrelation(res.correlationId)) {
      this.trainService.removeCorrelation(res.correlationId)
      if ((res.data.type && (res.data.type?.toLowerCase().includes("error") || res.data.type?.toLowerCase().includes("exception"))) || (res.data.bookingStatus && (res.data.bookingStatus?.toLowerCase().includes('unknown') || res.data.bookingStatus?.toLowerCase().includes('error')))) {
        if (res.data?.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else if (res?.data?.message?.toLowerCase().includes('invalid card') && this.trainsInfo.searchConfig.travellers.some((t: any) => t.selectedCard)) {
          this.translate
            .get(["train.invalid-card"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.invalid-card'
              );
            })
        } else if (res?.data?.message.includes("The itinerary has expired.")) {
          this.translate
            .get(["train.search-result.timer.end"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.search-result.timer.end'
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
            })
        }
        return true
      }
      console.log(res)
      return false
    }
  }

  onSelectSeats() {
    if (this.trainsInfo.selectedTrains.selectedReturnTrain) {
      this.trainsInfo.selectedTrains.selectedReturnTrain.seats = []
    }
     if (this.trainsInfo.selectedSeats && (this.trainsInfo.selectedSeats.outward.length > 0 || this.trainsInfo.selectedSeats.return.length > 0)) {
      this.trainsInfo.selectedTrains.selectedOutwardTrain.sections.forEach((s) => s.selectedSeats = this.trainsInfo.selectedSeats.outward.filter((seat) => seat.sectionId === s.sectionId) )
      if (this.trainsInfo.selectedTrains.selectedReturnTrain)
        this.trainsInfo.selectedTrains.selectedReturnTrain.sections.forEach((s) => s.selectedSeats = this.trainsInfo.selectedSeats.return.filter((seat) => seat.sectionId === s.sectionId) )
      const correlation = crypto.randomUUID();

      const request = {
        language: this.langService.getLanguage(),
        itineraryId: this.trainsInfo.itineraryId,
        seats: { ...this.trainsInfo.selectedSeats },
        correlationId: correlation,
        token: this.trainsInfo.token
      }
      this.trainService.addCorrelation(correlation);
      this.pendingRequests++;
      this.trainService.selectSeatsTrains(request).subscribe(
        (s) => {
        },
        (err) => {
        })
    }
    this.utilsService.loadingTrains = this.pendingRequests > 0;
  }

  selectSeatsResponse(res) {
    if (this.trainService.existsCorrelation(res.correlationId)) {
      this.trainService.removeCorrelation(res.correlationId)
      if ((res.data.type && (res.data.type?.toLowerCase().includes("error") || res.data.type?.toLowerCase().includes("exception"))) || (res.data.bookingStatus && (res.data.bookingStatus?.toLowerCase().includes('unknown') || res.data.bookingStatus?.toLowerCase().includes('error')))) {
        if (res.data?.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else if (res?.data?.message?.toLowerCase().includes('invalid card') && this.trainsInfo.searchConfig.travellers.some((t: any) => t.selectedCard)) {
          this.translate
            .get(["train.invalid-card"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.invalid-card'
              );
            })
        } else if (res?.data?.message.includes("The itinerary has expired.")) {
          this.translate
            .get(["train.search-result.timer.end"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.search-result.timer.end'
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
            })
        }
        return true
      }
      console.log(res) 
      return false
    }
  }

  thereIsExtras(leg) {
    return leg.extras && leg.extras.length > 0
  }
}
